var render = function render(){var _vm=this,_c=_vm._self._c;return _c('dl',{staticClass:"ui-kv"},_vm._l((_vm.rows),function(row){return _c('div',{key:row.key || row.label},[_c('dt',[_vm._v(_vm._s(row.label))]),_c('dd',{class:{ 'is-empty': _vm.isEmpty(row) }},[_vm._t("value",function(){return [_vm._v(_vm._s(row.value || _vm.emptyText))]},{"row":row})],2)])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }